import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTimes, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import styles from './Menu.module.css';

function Menu({ isOpen, onClose }) {
    const location = useLocation();

    // Bloquear scroll do corpo quando o menu estiver aberto
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.container} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeBtn} onClick={onClose}>
                    <FaTimes />
                </button>

                <nav className={styles.nav}>
                    <div className={styles.menuLabel}>NAVEGAÇÃO</div>
                    <ul className={styles.ul}>
                        <li style={{ "--i": 1 }}>
                            <Link to="/" className={location.pathname === '/' ? styles.active : ''} onClick={onClose}>
                                HOME
                            </Link>
                        </li>
                        <li style={{ "--i": 2 }}>
                            <Link to="/products" className={location.pathname === '/products' ? styles.active : ''} onClick={onClose}>
                                PRODUTOS
                            </Link>
                        </li>
                        <li style={{ "--i": 3 }}>
                            <Link to="/cart" className={location.pathname === '/cart' ? styles.active : ''} onClick={onClose}>
                                MEU CARRINHO
                            </Link>
                        </li>
                        <li style={{ "--i": 4 }}>
                            <Link to="/my-orders" className={location.pathname === '/my-orders' ? styles.active : ''} onClick={onClose}>
                                MEUS PEDIDOS
                            </Link>
                        </li>
                    </ul>
                </nav>

                <div className={styles.footerMenu}>
                    <div className={styles.socials}>
                        {/* Links reais ou botões para evitar o erro de acessibilidade */}
                        <a
                            href="https://www.instagram.com/jungleartigosmilitares/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href="https://wa.me/5547999999999"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                        >
                            <FaWhatsapp />
                        </a>
                    </div>
                    <p>JUNGLE GEAR // EQUIPAMENTOS ELITE</p>
                </div>
            </div>
        </div>
    );
};

export default Menu;